const e = "userGreetings_HMVUy", r = "userGreetings__Interactive_UX3nQ", t = "userGreetings__text_yWbCf", s = "userGreetings__IconWrapper_0i86Q", n = {
  userGreetings: e,
  userGreetings__Interactive: r,
  userGreetings__text: t,
  userGreetings__IconWrapper: s
};
export {
  n as default,
  e as userGreetings,
  s as userGreetings__IconWrapper,
  r as userGreetings__Interactive,
  t as userGreetings__text
};
//# sourceMappingURL=userGreetings.module.scss.js.map
